/**
 * Branded header – glass over hero on homepage/collection; solid bar elsewhere
 */
(function () {
  if (!document.body.classList.contains('header-home')) return;

  const sectionHeader = document.querySelector('.section-header');
  const headerWrapper = document.querySelector('.header-wrapper');
  const hero =
    document.querySelector('.hero-slider') ||
    document.querySelector('[data-collection-hero]');

  if (!sectionHeader || !headerWrapper) return;

  if (!hero) {
    sectionHeader.style.setProperty('--header-home-solid', '1');
    headerWrapper.classList.add('header-home--glass-off');
    return;
  }

  let ticking = false;
  const FADE_START = 140;
  const FADE_END = 50;

  function updateSolid() {
    ticking = false;
    const bottom = hero.getBoundingClientRect().bottom;
    let solid = 0;

    if (bottom <= FADE_END) {
      solid = 1;
    } else if (bottom < FADE_START) {
      solid = 1 - (bottom - FADE_END) / (FADE_START - FADE_END);
    }

    sectionHeader.style.setProperty('--header-home-solid', String(solid));
    headerWrapper.classList.toggle('header-home--glass-off', solid > 0.35);
    sectionHeader.classList.toggle('header-home--past-hero', solid > 0.65);
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(updateSolid);
    }
  }

  updateSolid();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', updateSolid);
})();
